{
  "nl": {},
  "de": {
    "housewarming-poster": "housewarming-poster",
    "relatiegeschenk-poster": "relatiegeschenk-poster",
    "bijzondere-locatie-poster": "special-location-poster",
    "lovemap-poster": "lovemap-poster",
    "sportsmap-poster": "sportsmap-poster",
    "date-poster": "date-poster",
    "woordenboek-poster": "dictionary-poster",
    "songtext-poster": "songtext-poster"
  }
}
